import MuiList, { type ListProps } from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import MuiListItemButton from '@mui/material/ListItemButton';
import MuiListItemText from '@mui/material/ListItemText';
import { classes, styles } from './utils';

export interface ResultsListProps extends Omit<
  ListProps,
  'results' | 'onSelect'
> {
  results: { label: string; value: number }[];
  onSelect: (id: number) => void;
}

export default function ResultsList({
  results = [],
  onSelect,
  ...props
}: ResultsListProps) {
  return (
    <MuiList disablePadding {...props}>
      {results.map(({ label, value }) => {
        return (
          <MuiListItem key={value} disablePadding>
            <MuiListItemButton
              sx={styles.listItemButton}
              className={classes.listItemButton}
              onClick={() => onSelect(value)}>
              <MuiListItemText primary={label} />
            </MuiListItemButton>
          </MuiListItem>
        );
      })}
    </MuiList>
  );
}
